import styled from "styled-components";
export const StyledButton = styled("button")<{ color?: string }>`
    background: ${(p) => p.color || "linear-gradient(299deg, #A30D51 6.54%, #DD1064 46.47%, #36C 107.41%, #2AFFDE 137.71%)"};
    color: ${(p) => (p.color ? "#2E186A" : "#fff")};
    font-size: 1rem;
    font-weight: 700;
    width: 100%;
    border: 1px solid #edf3f5;
    border-radius: 4px;
    padding: 13px 0;
    cursor: pointer;
    margin-top: 0.625rem;
    max-width: 180px;
    transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
    box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

    &:hover,
    &:active,
    &:focus {
        color: #fff;
        background: linear-gradient(347deg, #ffffff -85.86%, #36C 63.88%, #2AFFDE 108.86%);
    }
`;
